import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { 
  Box, 
  CardContent, 
  Typography
} from '@mui/material';
import { 
  AccountBalance as RefundIcon
} from '@mui/icons-material';
import { PageContainer, PageCard } from '../../common/components/styled-ui-elements';
import { RefundWorklistGrid } from '../components/grids';
import { RefundDashboardBackButton } from '../components/commands';
import { REFUND_WORKLIST_TYPES, RefundWorklistType } from '../../../services/RefundService';

const RefundWorklist: React.FC = () => {
  const [searchParams] = useSearchParams();
  const company = searchParams.get('company') || '';
  const center = searchParams.get('center') || '';
  const type = searchParams.get('type') || '';

  // Validate type parameter
  const selectedType: RefundWorklistType = REFUND_WORKLIST_TYPES.includes(type as RefundWorklistType) 
    ? (type as RefundWorklistType) 
    : 'Started';

  if (!company || !center || !type) {
    return (
      <PageContainer>
        <Box display="flex" justifyContent="center">
          <PageCard sx={{ maxWidth: 800 }}>
            <CardContent sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" color="error">
                Missing required parameters. Please specify company, center, and type to view refund worklist.
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: '#64748b' }}>
                Company: {company || 'Not specified'} | Center: {center || 'Not specified'} | Type: {type || 'Not specified'}
              </Typography>
            </CardContent>
          </PageCard>
        </Box>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          {/* Professional Header */}
          <Box sx={{ 
            backgroundColor: '#ffffff',
            borderBottom: '2px solid #3b82f6',
            p: 2.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <RefundIcon sx={{ fontSize: 32, color: '#3b82f6' }} />
              <Box>
                <Typography 
                  variant="h5" 
                  sx={{ 
                    fontWeight: 600, 
                    color: '#1e293b',
                    mb: 0.5
                  }}
                >
                  {selectedType} Refund Worklist
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ color: '#64748b' }}
                >
                  {company} | {center} | {selectedType}
                </Typography>
              </Box>
            </Box>
            <RefundDashboardBackButton
              company={company}
              center={center}
            />
          </Box>
          
          <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
            {/* Refund Worklist Grid */}
            <RefundWorklistGrid />
          </CardContent>
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default RefundWorklist;